import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { AccessRight } from 'lumen/utils/constants/users-constants';

interface ProductAccessRights {
  is_accessible: boolean;
  is_editable: boolean;
}

export interface UserProducts {
  rate_insight?: ProductAccessRights;
  revenue_insight?: ProductAccessRights;
}

export default class SubscriptionUser extends Model {
  [Type] = 'subscription-user' as const;

  @attr('string') declare email: string;
  @attr('boolean') declare isLocked: boolean | null;
  @attr('string') declare lastLogin: string | null;
  @attr('string') declare name: string;
  @attr() declare products: UserProducts | null;
  @attr('string') declare role: AccessRight;
}
